import Header from "./organisms/common/HeaderMinimal";
import Footer from "./organisms/common/FooterMinimal";
import SEO from "./organisms/common/SEO";

export default function Theme({ header, footer, seo, className, children }) {
  return (
    <>
      <SEO data={seo} />
      <main className={className}>
        <Header data={header} />
        {children}
        <Footer data={footer} />
      </main>
    </>
  );
}
